<template>
    <div class="hotel">
        <b-row>
            <b-col cols="12" md="2">
                <!--<b-form-group label="Carica da Expedia" label-for="eps_property_id" class="add-hotel">
                    <div class="service--item--add d-flex">
                        <b-form-input
                            class="add-hotel--input"
                            size="sm"
                            id="eps_property_id"
                            v-model="eps_property_id"
                            placeholder="Expedia Hotel ID"
                        ></b-form-input>
                        <b-badge class="add-hotel--badge" @click="get_eps_property_from_api" :variant="eps_property_id == '' ? 'light' : 'primary'">carica</b-badge>
                    </div>
                </b-form-group>-->

  <autocomplete
    :search="searchStruttura"
    size="sm"
    placeholder="Carica struttura"
    aria-label="Carica struttura"
    :get-result-value="getResultValue"
    @submit="handleSubmit"
    :debounceTime="1000"
  >
  
      <template #result="{ result, props }">
      <li v-if="!noResult"
        v-bind="props"
        class="autocomplete-result wiki-result"
      >
        <div class="titolo-struttura">
          {{ result.name }}
        </div>
      <li v-if="noResult && !isSearchInt"
        v-bind="props"
        class="autocomplete-result wiki-result"
      >
        <div>
          Struttura <b>{{searchString}}</b> non trovata... <br>
          <b-button title="crea una struttura" size="sm"  v-b-modal="'newStructForQuote'" >vuoi crearla?</b-button>

        </div>
      </li>
      <li v-if="noResult && isSearchInt"
        v-bind="props"
        class="autocomplete-result wiki-result"
      >
        <div>
          Struttura <b>{{searchString}}</b> non trovata... <br>
          <b-button title="carica una struttura" size="sm"  @click="get_eps_property_from_api()" >vuoi cercarla su Expedia?</b-button>

        </div>
      </li>
    </template>
  
  </autocomplete>
                                <b-modal :id="'newStructForQuote'" :title="'Nuova Struttura'" size="xl" hide-footer>
                                  <structures :structName="searchString"
                                        @closeModalStructures="(value) => closeModalStructures({
                                            id: 'newStructForQuote'
                                        })"
                                        @setNewStrutturaToQuote="(result) => setNewStrutturaToQuote(result)"
                                   />
                                </b-modal>

            </b-col>
            <b-col cols="12" md="3">
                <b-form-group id="property_name" label="Hotel" label-for="property_name">
                    <b-form-input
                        size="sm"
                        id="property_name"
                        v-model="property_name"
                        placeholder="Nome della struttura"
                        @input="updated"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
                <b-form-group id="address" label="Indirizzo" label-for="address">
                    <b-form-input
                        size="sm"
                        id="address"
                        v-model="address"
                        placeholder="Indirizzo"
                        @input="updated"
                    ></b-form-input>
                </b-form-group>                        
            </b-col>
            <b-col cols="12" md="2">
                <b-form-group id="city" label="Città" label-for="city">
                    <b-form-input
                        size="sm"
                        id="city"
                        v-model="city"
                        placeholder="Città"
                        @input="updated"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
                <b-form-group id="country_code" label="Country code" label-for="country_code">
                    <b-form-input
                        size="sm"
                        id="country_code"
                        v-model="country_code"
                        placeholder="Country code"
                        @input="updated"
                    ></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="12" md="3" offset-md="2">
                <label>
                    Checkin - Checkout
                </label>
                <div class="d-flex">
                    <b-form-group id="checkin" class="mr-1">
                        <b-form-group>
                            <b-input-group>
                                <b-form-input
                                    size="sm"
                                    id="checkin"
                                    v-model="checkin"
                                    placeholder="Checkin"
                                    disabled
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="secondary" v-b-toggle="'checkin_service_'+service_index+'hotel_'+hotel_index">
                                        <font-awesome-icon icon="pencil-alt" />
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <b-collapse :id="'checkin_service_'+service_index+'hotel_'+hotel_index">
                            <date-time-picker
                                :header="false"
                                :smart_inputs="true"
                                :day="checkin"
                                :context="{
                                    hotel_index: hotel_index
                                }"
                                @updated="(value) => refresh_date_checkin({
                                    day: value.day,
                                    context: value.context,
                                })"
                            />
                            </b-collapse>
                    </b-form-group>
                <!--</b-col>
                <b-col cols="12" md="2">-->
                    <b-form-group id="checkout" class="ml-1">
                        <b-form-group>
                            <b-input-group>
                                <b-form-input
                                    size="sm"
                                    id="checkout"
                                    v-model="checkout"
                                    placeholder="Checkout"
                                    disabled
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="secondary" v-b-toggle="'checkout_service_'+service_index+'hotel_'+hotel_index">
                                        <font-awesome-icon icon="pencil-alt" />
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <b-collapse :id="'checkout_service_'+service_index+'hotel_'+hotel_index">
                            <date-time-picker
                                :header="false"
                                :smart_inputs="true"
                                :day="checkout"
                                :context="{
                                    hotel_index: hotel_index
                                }"
                                @updated="(value) => refresh_date_checkout({
                                    day: value.day,
                                    context: value.context,
                                })"
                            />
                        </b-collapse>
                    </b-form-group>
                </div>
            </b-col>

            <b-col cols="12" md="5">
                <b-form-group id="property_info" :key="this.property_info">
                    <tiny-mce
                        :preview_mode="true"
                        :height="400"
                        :block_title="'Informazioni struttura'"
                        :initial_value="this.property_info"
                        @input="(value) => {
                            this.property_info = value
                            this.updated()
                        }"
                    />
                </b-form-group>
                <b-form-group id="property_important_info" :key="this.property_important_info">
                    <tiny-mce
                        :preview_mode="true"
                        :height="400"
                        :block_title="'Informazioni importanti'"
                        :initial_value="this.property_important_info"
                        @input="(value) => {
                            this.property_important_info = value
                            this.updated()
                        }"
                    />
                </b-form-group>
            </b-col>

        </b-row>

        <div>
            <div :key="rooms.length">
                <b-row v-for="(room,room_index) in rooms" v-bind:key="room_index" class="hotel--room">
                    <b-col cols="11">
                        <div class="hotel--room--panel">
                            <b-row>
                                <b-col cols="11">
                                    <room
                                        :room="room"
                                        :room_index="room_index"
                                        @updated="update_room_in_hotel"
                                    />
                                </b-col>
                                <b-col cols="1" class="d-flex align-items-center justify-content-center">
                                    <font-awesome-icon icon="times" @click="remove_room_from_hotel(room_index)"/>
                                    <font-awesome-icon icon="plus" @click="add_room_in_hotel"/>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>

            </div>
        </div>

        <!--
        <b-col cols="2" class="text-right">
            <b-badge @click="$emit('removed', {})" variant="danger">- hotel</b-badge>
        </b-col>
        -->
    </div>
</template>

<script>
    import TinyMce from '@/components/blocks/tiny-mce'
    import Vue from 'vue'
    import { get_eps_property, get_strutture_autocomp, get_struttura } from '@/api'
    import DateTimePicker from '@/components/blocks/date-time-picker'
    import Room from '@/components/blocks/overnight/room'
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import Structures from '@/components/blocks/structures'
    import { room } from '@/quote'
    export default {
        name: 'hotel',
        components: {
            'date-time-picker': DateTimePicker,
            'Autocomplete': Autocomplete,
            'room': Room,
            'tiny-mce': TinyMce,
            'structures': Structures,
        },
        props: {
            hotel: {
                type: Object,
                default: () => {}
            },
            hotel_index: Number,
            service_index: Number,
        },
        data() {
            return {
                noResult: true,
                isSearchInt: false,
                searchString: '',     
                //date_time_friendly: this.transfer.date_time_friendly,
                eps_property_id: '',
                property_name: this.hotel.property_name,
                address: this.hotel.address,
                city: this.hotel.city,
                country_code: this.hotel.country_code,
                checkin: this.hotel.checkin,
                checkout: this.hotel.checkout,
                rooms: this.hotel.rooms,

                // per ora inutilizzati
                coordinates: this.hotel.coordinates,
                cover_url: this.hotel.cover_url,
                gallery: this.hotel.gallery,

                property_info: this.hotel.property_info,
                property_important_info: this.hotel.property_important_info,
            }
        },
        methods:
        {
            overnightQuoteFeed(payload)
            {

                    this.address = payload.address
                    this.coordinates = {
                      latitude: payload.coordinates.latitude,
                      longitude: payload.coordinates.longitude
                    }

                    this.city = payload.city
                    this.country_code = payload.country_code
                    this.gallery = payload.gallery
                    this.cover_url = payload.cover_url
                    this.property_name = payload.name
                    this.property_info = payload.property_info,
                    this.property_important_info = payload.property_important_info
                    this.updated()

            },
            updated()
            {
                let payload = {
                    hotel_index: this.hotel_index,
                    hotel: {
                        ...this.hotel,
                        property_name: this.property_name,
                        address: this.address,
                        city: this.city,
                        country_code: this.country_code,
                        checkin: this.checkin,
                        checkout: this.checkout,
                        rooms: this.rooms,
                        coordinates: this.coordinates,
                        cover_url: this.cover_url,
                        gallery: this.gallery,
                        property_info: this.property_info,
                        property_important_info: this.property_important_info,
                    }
                }
                this.$emit('updated', payload)
            },
            closeModalStructures(param)
            {
                this.$bvModal.hide(param.id)
            },
            setNewStrutturaToQuote(payload)
            {
                this.overnightQuoteFeed(payload.original.struttura);
            },
            refresh_date_checkin(payload)
            {
                this.checkin = payload.day
                this.updated()
            },
            refresh_date_checkout(payload)
            {
                this.checkout = payload.day
                this.updated()
            },
            add_room_in_hotel()
            {
                this.rooms.push(room)
                this.updated()
            },
            remove_room_from_hotel(room_index)
            {
                this.rooms.splice(room_index,1)
                this.updated()
            },
            update_room_in_hotel(payload)
            {
                this.rooms[payload.room_index] = payload.room
                this.updated()
            },
            get_eps_property_from_api()
            {
                if(this.eps_property_id == ''){
                  Vue.$toast.error('invalid hotel id')
                  return
                }

                Vue.$toast.info('cerco hotel expedia ' + this.eps_property_id)

                get_eps_property({
                    eps_property_id: this.eps_property_id,
                })
                    .then(
                        
                        (success) => {

                            Vue.$toast.success('trovato: ' + success.data.overnight_hotel.property_name)

                            this.address = success.data.overnight_hotel.address
                            this.coordinates = success.data.overnight_hotel.coordinates
                            this.city = success.data.overnight_hotel.city
                            this.country_code = success.data.overnight_hotel.country_code
                            this.cover_url = success.data.overnight_hotel.coverUrl
                            this.gallery = success.data.overnight_hotel.gallery
                            this.property_name = success.data.overnight_hotel.property_name
                            //this.rooms = success.data.overnight_hotel.rooms
                            this.property_info = success.data.overnight_hotel.property_info,
                            this.property_important_info = success.data.overnight_hotel.property_important_info,
                            this.updated()
                        },

                        (error) => {(error)}

                    )
            },
            searchStruttura(input) {
            this.value = input
            this.searchString = this.value
            return new Promise(resolve => {


            if(isNaN(input)){
                this.isSearchInt = false
                if (input.length < 3) {
                return resolve([])
                }
                
                let payload = {
                        str: this.value
                }

                get_strutture_autocomp(payload).then(
                    (data) => {
                        if (this.value) {
                            if(!data.result[0].length < 2 && !data.result[0].name) {
                                this.noResult = true
                            } else {
                                this.noResult = false
                            }
                            resolve(data.result)
                        } else {
                            resolve([])
                        }
                    }
                )
            }else{
                if (input.length > 1) {
                this.noResult = true
                this.isSearchInt = true
                this.eps_property_id = input
                resolve([[]])
                } else {
                    return resolve([])
                }
            }


            })
            },
            getResultValue(result) {
                
                if(result.name){
                return result.name
                }

            },
            handleSubmit(result) {

                if(!this.noResult){

                get_struttura({
                    id: result.id,
                    'autocompSubmitForQuote': 1
                })
                    .then(
                        
                        (success) => {

                            Vue.$toast.success('trovato: ' + success.struttura.name)
                            this.overnightQuoteFeed(success.struttura);

                        },

                        (error) => {(error)}

                    )

                }

            }
        }
    }
</script>

<style lang="scss">
    .hotel
    {
        #property_info.form-group,
        #property_important_info.form-group
        {
            margin-bottom:0;
        }
        &--datetime--label
        {
            width:100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        &--room
        {
            display: flex;
            align-items: center;
        }
        .add-hotel
        {
            &--input
            {
                border-top-right-radius:0;
                border-bottom-right-radius:0;
                padding-right:28px;
                color:$primary;
                &::placeholder
                {
                    //color:$primary;
                }
            }
            &--badge
            {
                margin-left:-20px;
                color:$white;
                &.badge-light
                {
                    cursor: initial;
                    color:rgba($black,0.5);
                }
            }
        }

        &--room--panel
        {
            @include subpanel;
            background:rgba($gray-100,1);
        }
    }
</style>